import React from "react";
import { Button, Alert, Modal, Grid, Row, Col } from "react-bootstrap";
import { goTo, FieldGroup } from "../../GlobalTools";

const SuccessView = ({ os, openContentWindow, item, user}) => (
  <div className="success mtop-40">
    <Grid>
      {/*<Row>
      <Col xs={12} className="text-center">
        <img src='/assets/img/icons/upvote.png'/><br/>
      </Col>
    </Row>*/}
      <Row className="mbottom-10">
        <Col xs={12}>
          <img
            src="/assets/img/faver_sent.svg"
            className="center-block"
            style={{ height: "100%" }}
          />
          <img
            src={item.image? item.image : "/assets/img/logo_faver_bw.svg"}
            className={item.image? "center-block mtop-30 mbottom-30 content-img-success": "center-block mtop-30 mbottom-30"}
            style={{ height: "100%" }}
          />
          <p className="title-succes"> {user.first_name + " "} stored your recommendation in FAVER!</p>
          <p className="subtitle-succes mtop-20">
            Get and save recommendations from those you trust
          </p>
        </Col>
      </Row>

      {/*<Row>
      <Col xs={12} smOffset={3} sm={6} className="section-without-paading">
        <div className="section-with-paading">
          <Row className="mbottom-10">
            <Col xs={2} sm={1}>
              <img src='/assets/img/icons/upvote.png' style={{height: 25}}/>
            </Col>
            <Col xs={10} sm={11} className="text-point">
              <p>Find the best of everything, from movies, to books & videogames.</p>
            </Col>
          </Row>
          <Row className="mbottom-10">
            <Col xs={2} sm={1}>
              <img src='/assets/img/icons/upvote.png' style={{height: 25}}/>
            </Col>
            <Col xs={10} sm={11} className="text-point">
              <p>Connect with your most trusted friends to get & give better recommendations.</p>
            </Col>
          </Row>
          <Row className="mbottom-10">
            <Col xs={2} sm={1}>
              <img src='/assets/img/icons/upvote.png' style={{height: 25}}/>
            </Col>
            <Col xs={10} sm={11} className="text-point">
              <p>Get custom recommentadions based on your faves.</p>
            </Col>
          </Row>
          <Row className="mbottom-10">
            <Col xs={2} sm={1}>
              <img src='/assets/img/icons/upvote.png' style={{height: 25}}/>
            </Col>
            <Col xs={10} sm={11} className="text-point">
              <p>Save items for later, so you're never caught wondering what to discover next.</p>
            </Col>
          </Row>
        </div>
      </Col>      
    </Row>*/}

      <Row className="mtop-10">
        <Col xs={12} sm={6}>
          <Button
            className="col-xs-12 btn btn-faver"
            style={{marginBottom: 20,  height: 60}}
            onClick={() => openContentWindow("https://play.google.com/store/apps/details?id=com.faver.faverapp")}
          >
            <img src="/assets/img/android-logo.png" style={{ paddingRight: 10 }}/>
            Download<span style={{ fontWeight: "bold" }}> FAVER</span>
          </Button>
        </Col>  

        <Col xs={12} sm={6}>
          <Button
            className="col-xs-12 btn btn-faver"
            style={{marginBottom: 20, height: 60}}
            onClick={() => openContentWindow("https://apps.apple.com/us/app/faver/id1515531187")}
          >
            <img src="/assets/img/apple.png" style={{ paddingRight: 10 }}/>
            Download<span style={{ fontWeight: "bold" }}> FAVER</span>
          </Button>
        </Col>
      </Row>

      {/*<Row className="mtop-20 mbottom-40">
      <Col xs={12} className="text-footer">
        <p>Life is Short. Find the Best.</p>
      </Col>
    </Row>*/}
    </Grid>
  </div>
);

export default SuccessView;



// WEBPACK FOOTER //
// ./src/client/views/dashboard/SuccessView.js